import WaitlistForm from '../../components/base/WaitlistForm';
import Orb from '../../components/base/Orb';

export default function Home() {
  const scrollToWaitlist = () => {
    document.getElementById('waitlist-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen font-sans relative overflow-hidden bg-black">
      {/* Animated Orb Background */}
      <div className="absolute inset-0 z-0">
        <Orb hue={0} hoverIntensity={0.3} rotateOnHover={true} />
      </div>

      {/* Content */}
      <div className="relative z-10 min-h-screen pointer-events-none">
        {/* Header */}
        <header className="w-full py-5 px-8 pointer-events-auto">
          <div className="container mx-auto flex justify-between items-center">
            <a href="#" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/bbc5f99c299d28fc8d3cc3154912fe5e.png"
                alt="Cybernetic Genius"
                className="h-48 w-auto object-contain"
              />
            </a>
            <div className="flex items-center gap-4">
              <button
                onClick={scrollToWaitlist}
                className="px-4 py-2 bg-white text-gray-900 text-sm rounded-full whitespace-nowrap hover:bg-gray-100 transition-all cursor-pointer"
              >
                Get Early Access
              </button>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="container mx-auto px-8 flex items-center min-h-[80vh] pointer-events-auto">
          <div className="flex flex-col items-center text-center max-w-4xl mx-auto w-full">

            {/* Badge */}
            <div className="mb-6 px-4 py-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full text-xs text-gray-300 tracking-widest uppercase">
              Next-Gen AI Intelligence
            </div>

            {/* Hero Title */}
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-5 tracking-tight text-white text-center max-w-[90%] xl:max-w-[80%] 2xl:max-w-[70%] mx-auto leading-tight">
              Augment Your Mind.<br />Amplify Your Potential.
            </h2>

            {/* Tagline */}
            <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed">
              Cybernetic Genius merges human intuition with machine intelligence — empowering you to think faster, create smarter, and achieve the extraordinary.
            </p>

            {/* Waitlist Form */}
            <div id="waitlist-section" className="w-full flex flex-col items-center">
              <WaitlistForm />
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="pointer-events-auto w-full py-10 px-8 mt-8 bg-white/5 backdrop-blur-sm border-t border-white/10">
          <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Brand */}
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/bbc5f99c299d28fc8d3cc3154912fe5e.png"
                alt="Cybernetic Genius"
                className="h-10 w-auto object-contain"
              />
              <span className="text-white/60 text-sm">&copy; {new Date().getFullYear()} Cybernetic Genius. All rights reserved.</span>
            </div>

            {/* Links */}
            <div className="flex items-center gap-6 text-sm text-white/50">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-4">
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 border border-white/20 rounded-full transition-all cursor-pointer" aria-label="Twitter / X">
                <i className="ri-twitter-x-line text-white text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 border border-white/20 rounded-full transition-all cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-line text-white text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 border border-white/20 rounded-full transition-all cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-white text-sm"></i>
              </a>
              <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 border border-white/20 rounded-full transition-all cursor-pointer" aria-label="Discord">
                <i className="ri-discord-line text-white text-sm"></i>
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
